import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import type {
  IIssueApi,
  TDeleteIssuesParams,
  TGetIssueByIdParams,
  TGetIssuesParams,
  TUpdateIssueByIdParams,
  TUpdateIssueByIdRequestBody,
  TUpdateIssueTaskParams,
  TUpdateIssueTaskRequestBody
} from '@/types/api-types/issues'
import { expandedProperties } from '@/utils/constants'
import BaseApiRequest from '../BaseApiRequest'
import IssueApiUrl from './endpoints'

class IssueApiRequest extends BaseApiRequest implements IIssueApi {
  async getIssue(params: TGetIssueByIdParams): TApiResponse {
    const { jobId, ...rest } = params
    const url = `${IssueApiUrl.ISSUE_BY_ID(params.jobId)}`
    return this.get(url, rest)
  }

  async updateIssue(
    params: TUpdateIssueByIdParams,
    requestBody: TUpdateIssueByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${IssueApiUrl.ISSUE_BY_ID (id)}`
    return this.put(url, requestBody, {...rest})
  }

  async updateIssueTask(
    params: TUpdateIssueTaskParams,
    requestBody: TUpdateIssueTaskRequestBody
  ): TApiResponse {
    const { jobId, taskId } = params
    const url = `${IssueApiUrl.ISSUE_TASK_BY_ID(jobId, taskId)}`
    return this.put(url, requestBody)
  }

  async getIssues(params: TGetIssuesParams): TApiResponse {
    return this.get(IssueApiUrl.ISSUES(), params)
  }

  async deleteIssues(params?: TDeleteIssuesParams): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(IssueApiUrl.ISSUES(), params)
  }

  async createIssue(requestBody: TUpdateIssueByIdRequestBody): TApiResponse {
    return this.post(IssueApiUrl.ISSUES(), requestBody, { ...expandedProperties })
  }
}

export default IssueApiRequest
